module.exports = __webpack_public_path__ + "img/outcome_fully_automated.419a5bf8.svg";